<template>
  <v-container>
    <v-card flat>
      <v-card-text>
        <v-btn color="primary" @click="$router.go(-1)">
          <v-icon left> mdi-arrow-left </v-icon>
          Back to checklist
        </v-btn>
      </v-card-text>

      <component :is="component" />
    </v-card>
  </v-container>
</template>

<script>
import bio from "../../profile/modules/account/AccountInfo.vue";
import contact from "../../profile/modules/contact/contact.vue";
import academic from "../../profile/modules/academic/academic";
import experience from "../../profile/modules/experience/experience";
import referee from "../../profile/modules/referee/referee";
import specialization from "../../profile/modules/specialization/specialization.vue";

export default {
  name: "ComponentCard",
  data: function () {
    return {
      modal: false,
      component: { template: "<div>Loading Component</div>" },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.loadComponent(to.params.name);
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch("Profile/getAllSetup");
    });
  },
  methods: {
    loadComponent: function (component) {
      switch (component.toLowerCase()) {
        case "profile":
        case "picture":
        case "residence":
        case "id":
          this.component = bio;
          break;
        case "contacts":
          this.component = contact;
          break;
        case "education":
        case "professional":
          this.component = academic;
          break;
        case "work experience":
          this.component = experience;
          break;
        case "referee":
          this.component = referee;
          break;
        case "specialization":
          this.component = specialization;
          break;
        default:
          this.component = { template: "<div>Loading Component</div>" };
      }
    },
  },
};
</script>

<style scoped></style>
